import { TableCell, TableRow } from "@mui/material";
import styles from "../creditreport.module.css";

function goalStatus(pct) {
    if (pct >= 100) return { label: "Completed", cls: "statusCompleted" };
    if (pct >= 70) return { label: "On track", cls: "statusOnTrack" };
    if (pct >= 40) return { label: "In progress", cls: "statusProgress" };
    return { label: "Starting", cls: "statusStarting" };
}

const GOAL_COLORS = ["#f48272", "#e8a93c", "#7c72cc", "#1d9e75", "#f97316"];

const GoalExpandPanel = ({ goals, colSpan = 5 }) => {
    return (<TableRow className={styles.goalPanelRow}>
        <TableCell colSpan={colSpan} className={styles.goalPanelCell}>
            <div className={styles.goalPanelInner}>
                <p className={styles.goalPanelTitle}>Financial goals</p>
                <div className={styles.goalCardGrid}>
                    {goals.map((g, i) => {
                        const status = goalStatus(g.pct);
                        const color = GOAL_COLORS[i % GOAL_COLORS.length];
                        return (
                            <div key={i} className={styles.goalCard}>
                                <div className={styles.goalCardLabel}>
                                    <span className={styles.goalCardDot} style={{ background: color }} />
                                    {g.label}
                                </div>
                                <div className={styles.goalCardBarBg}>
                                    <div
                                        className={styles.goalCardBarFill}
                                        style={{ width: `${g.pct}%`, background: color }}
                                    />
                                </div>
                                <div className={styles.goalCardFooter}>
                                    <span className={styles.goalCardPct}>{g.pct}%</span>
                                    <span className={`${styles.goalStatusBadge} ${styles[status.cls]}`}>
                                        {status.label}
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </TableCell>
    </TableRow>);
}

export default GoalExpandPanel;